export const COLORS = {
    PRIMARY: "#1E2A38",
    DARK_BLUE: "#1E2A38",
    ORANGE: "#D2550F",
    SECONDARY: "#D2550F",
    LIGHT_GREY: "#F5F5F5",
    BLACK_FONT: "#282828",
    WHITE: "#FFFFFF"
}